import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Select from "react-select";
import { CheckSquare, Square } from "lucide-react";
import axiosInstance from "../../axiosInterceptor";
import { customStyles } from "../../utils/constant";
import { subMenuSchema } from "../../Validation/Validation";
import { useMemo } from "react";

const AddSubMenu = () => {
  const { menuId } = useParams();
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const [pageData, setPageData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const fetchAllData = async () => {
    const apiList = [
      {
        url: "pageBuilder/getallpagebuilder",
        setter: setPageData,
      },
      {
        url: "service/getallservice",
        setter: setServiceData,
      },
      {
        url: "category/getallcategory",
        setter: setCategoryData,
      },
    ];

    try {
      const responses = await Promise.all(
        apiList.map((item) => axiosInstance.get(item.url)),
      );

      responses.forEach((res, index) => {
        apiList[index].setter(res.data?.data || []);
      });
    } catch (err) {
      setPageData([]);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const initalvalues = useMemo(() => ({
    sortOrder: editData?.sortOrder || 1,
    subMenuName: editData?.subMenuName || "",
    subMenuType: editData?.subMenuType || "",
    subMenuUrl: editData?.subMenuUrl || "",
    menuId: menuId || editData?.menuId?._id,
    pageBuilderId: editData?.pageBuilderId || null,
    serviceId: editData?.serviceId || null,
    categoryId: editData?.categoryId || null,
    isActive: editData?.isActive ?? true,
    showInHeader: editData?.showInHeader ?? false,
    showInFooter: editData?.showInFooter ?? false,
    metaTitle: editData?.metaTitle || "",
    metaDescription: editData?.metaDescription || "",
    metaKeywords: editData?.metaKeywords || "",
  }), [editData, menuId]);

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
    touched } = useFormik({
      initialValues: initalvalues,
      enableReinitialize: true,
      validationSchema: subMenuSchema,

      onSubmit: async (values) => {
        setLoading(true);

        try {

          const response = editingId
            ? await axiosInstance.put(
              `/submenu/updatesubmenu/${editingId}`,
              values
            )
            : await axiosInstance.post(
              "/submenu/createsubmenu",
              values
            );

          if (response.status === 200 || response.status === 201) {
            toast.success(response.data?.message || "Saved successfully");

            navigator(`/submenu/${menuId}`);
          }
        } catch (error) {
          console.error("SUB MENU ERROR:", error);

          toast.error(
            error.response?.data?.message ||
            error.message ||
            "Something went wrong"
          );
        } finally {
          setLoading(false);
        }
      },
    });

  const subMenuType = [
    { label: "Service", value: "Service" },
    { label: "Category", value: "Category" },
    { label: "Page", value: "Page" }
  ];
  useEffect(() => {
    if (
      values.subMenuType === "Category" &&
      values.categoryId &&
      categoryData.length
    ) {
      const category = categoryData.find(
        (item) => item._id === values.categoryId
      );

      if (category) {
        setFieldValue("subMenuUrl", category.url);
      }
    }
  }, [
    values.subMenuType,
    values.categoryId,
    categoryData,
  ]);
  useEffect(() => {
    if (
      values.subMenuType === "Service" &&
      values.serviceId &&
      serviceData.length
    ) {
      const category = serviceData.find(
        (item) => item._id === values.serviceId
      );

      if (category) {
        setFieldValue("subMenuUrl", category.url);
      }
    }
  }, [
    values.subMenuType,
    values.serviceId,
    serviceData,
  ]);


  const pageBuilderOptions = pageData.map((item) => ({
    label: item.title,
    value: item._id,
  }));

  const categoryOptions = categoryData.map((item) => ({
    label: item.name,
    value: item._id,
    url: item.url,
  }));

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Sub Menu
          </h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="menu-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="menu-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="menu-subMenuType"
                        className="col-form-label "
                      >
                        Select Sub Menu Type
                      </label>
                      <Select
                        placeholder=" Select Menu Type"
                        isClearable
                        styles={customStyles}
                        options={subMenuType}
                        value={
                          subMenuType.find(
                            (opt) => opt.label === values.subMenuType,
                          ) || null
                        }
                        onChange={(option) =>
                          setFieldValue(
                            "subMenuType",
                            option ? option.label : null,
                          )
                        }
                        name="subMenuType"
                      />
                      {touched.subMenuType && errors.subMenuType && (
                        <small className="text-danger">
                          {errors.subMenuType}
                        </small>
                      )}
                    </div>
                  </div>

                  {values.subMenuType === "Page" && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="subMenuPage"
                          className="col-form-label "
                        >
                          Select Page
                        </label>
                        <Select
                          placeholder=" Select page"
                          isClearable
                          styles={customStyles}
                          options={pageBuilderOptions}
                          value={
                            pageBuilderOptions.find(
                              (opt) => opt.value === values.pageBuilderId,
                            ) || null
                          }
                          onChange={(option) => {
                            setFieldValue("pageBuilderId", option ? option.value : null);
                          }}
                          name="pageBuilderId"
                        />
                        {touched.pageBuilderId && errors.pageBuilderId && (
                          <small className="text-danger">
                            {errors.pageBuilderId}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {values.subMenuType === "Category" && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="subMenuProjectType"
                          className="col-form-label "
                        >
                          Select Category
                        </label>
                        <Select
                          placeholder="Select Category"
                          isClearable
                          styles={customStyles}
                          options={categoryOptions}
                          value={
                            categoryOptions.find(
                              (opt) => opt.value === values.categoryId
                            ) || null
                          }
                          onChange={(option) => {
                            setFieldValue("categoryId", option ? option.value : null);
                            setFieldValue("subMenuUrl", option ? option.url : "");
                          }}
                          name="categoryId"
                        />
                        {touched.categoryId && errors.categoryId && (
                          <small className="text-danger">
                            {errors.categoryId}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {values.subMenuType === "Service" && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="subMenuCategory"
                          className="col-form-label "
                        >
                          Select Services
                        </label>
                        <Select
                          placeholder=" Select Category"
                          isClearable
                          styles={customStyles}
                          options={categoryOptions}
                          value={
                            categoryOptions.find(
                              (opt) => opt.value === values.serviceId,
                            ) || null
                          }

                          onChange={(option) => {
                            setFieldValue(
                              "serviceId",
                              option ? option.value : null,
                            );
                          }}
                          name="serviceId"
                        />
                        {touched.serviceId && errors.serviceId && (
                          <small className="text-danger">
                            {errors.serviceId}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="subMenuName" className="col-form-label ">
                        Sub Menu Name
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="subMenuName"
                        name="subMenuName"
                        placeholder="Enter Menu Name"
                        value={values.subMenuName}
                        onChange={handleChange}
                      />
                      {touched.subMenuName && errors.subMenuName && (
                        <small className="text-danger">
                          {errors.subMenuName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="subMenuUrl" className="col-form-label ">
                        Sub Menu Url
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="subMenuUrl"
                        name="subMenuUrl"
                        placeholder="Enter Menu Url"
                        value={values.subMenuUrl}
                        onChange={handleChange}
                        readOnly={["Category"].includes(values.subMenuType)}
                      />
                      {touched.subMenuUrl && errors.subMenuUrl && (
                        <small className="text-danger">
                          {errors.subMenuUrl}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaTitle" className="col-form-label ">
                        Meta Title
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="metaTitle"
                        name="metaTitle"
                        placeholder="Enter Meta Title"
                        value={values.metaTitle}
                        onChange={handleChange}
                      />
                      {touched.metaTitle && errors.metaTitle && (
                        <small className="text-danger">
                          {errors.metaTitle}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaKeywords" className="col-form-label ">
                        Meta Keywords
                      </label>
                      <textarea
                        className="form-control  border-dark "
                        id="metaKeywords"
                        name="metaKeywords"
                        placeholder="Enter Meta Keywords"
                        style={{
                          resize: "vertical",
                          minHeight: "10px",
                        }}
                        value={values.metaKeywords}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaKeywords && errors.metaKeywords && (
                        <small className="text-danger">
                          {errors.metaKeywords}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="metaDescription"
                        className="col-form-label"
                      >
                        Meta Description
                      </label>
                      <textarea
                        className="form-control border-dark"
                        id="metaDescription"
                        name="metaDescription"
                        placeholder="Enter Meta Description"
                        style={{
                          resize: "vertical",
                          minHeight: "45px",
                        }}
                        value={values.metaDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaDescription && errors.metaDescription && (
                        <small className="text-danger">
                          {errors.metaDescription}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>

                  <div className="col-md-6 mt-4">
                    <div
                      className="d-flex flex-column "
                      style={{ gap: "10px" }}
                    >
                      <div
                        className={`menu-row ${values.showInHeader ? "active" : ""
                          }`}
                        onClick={() =>
                          setFieldValue("showInHeader", !values.showInHeader)
                        }
                      >
                        {values.showInHeader ? (
                          <CheckSquare size={20} className="icon-active" />
                        ) : (
                          <Square size={20} className="icon" />
                        )}

                        <span className="menu-title">Show In Header</span>
                      </div>
                      <div
                        className={`menu-row ${values.showInFooter ? "active" : ""
                          }`}
                        onClick={() =>
                          setFieldValue("showInFooter", !values.showInFooter)
                        }
                      >
                        {values.showInFooter ? (
                          <CheckSquare size={20} className="icon-active" />
                        ) : (
                          <Square size={20} className="icon" />
                        )}
                        <span className="menu-title">Show In Footer</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="text-start mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to={`/submenu/${menuId}`}>
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubMenu;
